/*
 * Welcome Popup (Trigger CRO #5)
 * <dialog>.showModal() garantisce focus trap nativo del browser + chiusura con Esc.
 * Gate: solo homepage (gia' garantito lato Liquid), dopo N secondi, una volta per
 * dispositivo via localStorage. Vanilla JS, IIFE, guard readyState,
 * re-init su shopify:section:load per il theme editor.
 */
(function () {
  function focusableIn(root) {
    return Array.from(
      root.querySelectorAll(
        "a[href], button:not([disabled]), textarea:not([disabled]), input:not([type=hidden]):not([disabled]), select:not([disabled]), [tabindex]:not([tabindex='-1'])"
      )
    );
  }

  function initPopup(el) {
    if (!el || el.dataset.daInit === 'true') return;
    el.dataset.daInit = 'true';

    const dialog = el.querySelector('[data-popup-dialog]');
    if (!dialog) return;

    const closeBtn = el.querySelector('[data-popup-close]');
    const storageKey = el.dataset.storageKey || 'da-welcome-popup';
    const repeat = el.dataset.repeat === 'true';
    const delay = (parseInt(el.dataset.delay || '8', 10) || 8) * 1000;
    const inEditor = Boolean(window.Shopify && window.Shopify.designMode);

    let seen = false;
    try {
      seen = localStorage.getItem(storageKey) === '1';
    } catch (e) {
      seen = false;
    }

    const hasSuccess = Boolean(el.querySelector('[data-popup-success]'));

    function markSeen() {
      try {
        localStorage.setItem(storageKey, '1');
      } catch (e) {
        /* storage non disponibile: ignora */
      }
    }

    let timer = null;

    function open() {
      if (dialog.open) return;
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      const target = focusableIn(dialog)[0];
      if (target) target.focus();
      if (!repeat) markSeen();
    }

    function close() {
      if (typeof dialog.close === 'function' && dialog.open) {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
    }

    closeBtn?.addEventListener('click', close);

    // Chiudi cliccando sul backdrop (fuori dal contenuto).
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) close();
    });

    // Post-invio: la pagina si e' ricaricata, mostra subito la conferma e
    // marca come visto (non ripianificare).
    if (hasSuccess) {
      markSeen();
      open();
      return;
    }

    // In editor: apri subito per l'anteprima. Altrimenti rispetta gate + delay.
    if (inEditor) {
      open();
      return;
    }

    if (seen && !repeat) return;

    timer = window.setTimeout(open, delay);

    el._daCleanup = function () {
      if (timer) window.clearTimeout(timer);
    };
  }

  function initAll() {
    document.querySelectorAll('da-welcome-popup').forEach(initPopup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const el = event.target.querySelector
      ? event.target.querySelector('da-welcome-popup')
      : null;
    if (el) initPopup(el);
  });
})();
